

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormBase, FormInput, FormTextarea, FormError, FormSubmit, FormSelect } from "./parts";

@Component({
    components: {
        FormBase,
        FormInput,
        FormTextarea,
        FormError,
        FormSubmit,
        FormSelect
    }
})
export default class ImageVideoForm extends Vue {
    @Prop() contactEmail!: string;

    @Prop({ default: "dark" }) theme!: string;

    @Prop({ default: () => [] }) types!: string[];

    payload: any = {
        type: "",
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        message: "",
        contact_email: this.contactEmail
    };

    errorResponse: ErrorResponse = {
        status: 0,
        errors: []
    };

    success_message = "";

    private submit(form: FormClass) {
        this.success_message = "";
        // @ts-ignore
        axios
            .post(`/api/forms/image-video-form`, this.payload)
            .then((response: any) => {
                // @ts-ignore
                if (window.hasOwnProperty("dataLayer") && dataLayer) {
                    // @ts-ignore
                    dataLayer.push({
                        event: "formSubmission",
                        formId: "1",
                        response: [
                            { name: "first_name", value: this.payload.first_name },
                            { name: "last_name", value: this.payload.last_name },
                            { name: "email", value: this.payload.email },
                            { name: "phone", value: this.payload.phone },
                            { name: "message", value: this.payload.message },
                            { name: "href", value: window.location.href },
                            { name: "pathname", value: window.location.pathname }
                        ]
                    });
                }

                this.payload = {
                    type: "",
                    email: "",
                    first_name: "",
                    last_name: "",
                    phone: "",
                    message: "",
                    contact_email: this.contactEmail
                };

                this.success_message = 'We hebben je vraag goed ontvangen en nemen binnen de 2 dagen contact met je op. Sneller antwoord nodig? Bel ons dan even op <a href="tel:035508011" class="text-orange hub-contact-info">03 550 80 11</a>';
            })
            .catch((e: { response: { data: ErrorResponse } }) => {
                this.errorResponse = e.response.data;
            })
            .finally(() => {
                form.reset();
            });
    }
}
